import { API, DOMAIN } from '@autopass-web/domain';
import HttpClient, { parseResponse } from '../http-client';

const PARKING_TICKETS = 'parking_tickets';
const INVOICES = 'invoices';
const SELF_SERVICE_REFUELING = 'self_service_refueling';
const GUEST_ALPR_SERVICE = 'guest_alpr_service';

// const APS = 'aps';
// const CHAIN_STORE = 'chain_store';

const LINE_PAY = 'line_pay';
const APPLE_PAY = 'apple_pay';
const CREDIT_CARD = 'credit_card';
const EASY_WALLET = 'easy_wallet';
const JKOPAY = 'jkopay';

class PaymentHttpClient extends HttpClient {
  paymentHttpClient;
  paymentApiConfig;

  constructor(props: any) {
    super(props);
    this.apiConfig = DOMAIN.API_URL[API.USER];
    this.httpClient = this.createHttpClient({
      headers: this.apiConfig.headers,
      baseUrl: this.apiConfig.baseUrl,
    });

    this.httpClient.interceptors.request.use((value: any) =>
      this.interceptRequest(value),
    );
    this.httpClient.interceptors.response.use(
      (value: any) => this.interceptResponseResult(value),
      (error: any) => this.interceptResponseError(error, this.httpClient),
    );

    this.paymentApiConfig = DOMAIN.API_URL[API.PAYMENT];
    this.paymentHttpClient = this.createHttpClient({
      headers: this.paymentApiConfig.headers,
      baseUrl: this.paymentApiConfig.baseUrl,
    });

    this.paymentHttpClient.interceptors.request.use((value: any) =>
      this.interceptRequest(value),
    );
    this.paymentHttpClient.interceptors.response.use(
      (value: any) => this.interceptResponseResult(value),
      (error: any) => this.interceptResponseError(error, this.httpClient),
    );
  }

  paymentPost = (apiPath = '', params = {}) =>
    parseResponse(this.paymentHttpClient.post(`${apiPath}`, params));

  // 自助加油 --------------

  selfServiceRefuelingCreateTransaction = ({
    parkingCellId,
    email,
    ubn,
  }: {
    parkingCellId: string;
    email: string;
    ubn: string;
  }) =>
    this.post(`${SELF_SERVICE_REFUELING}/${parkingCellId}/create_transaction`, {
      email,
      ubn,
    });

  selfServiceRefuelingAuthApplePay = ({
    parkingCellId,
    applePayPaymentInfo,
    email,
    ubn = '',
  }: {
    parkingCellId: string;
    applePayPaymentInfo: {};
    email: string;
    ubn: string;
  }) =>
    this.post(`${SELF_SERVICE_REFUELING}/${APPLE_PAY}/auth`, {
      parking_cell_id: parkingCellId,
      apple_pay_payment_info: applePayPaymentInfo,
      billing_contact: {
        email_address: email,
      },
      type: 'web',
      ubn,
    });

  selfServiceRefuelingAuthLinePay = ({
    parkingCellId,
    token,
    transactionId,
  }: {
    parkingCellId: string;
    token: string;
    transactionId: string;
  }) =>
    this.post(`${SELF_SERVICE_REFUELING}/${LINE_PAY}/auth`, {
      parking_cell_id: parkingCellId,
      token,
      transaction_id: transactionId,
    });

  selfServiceRefuelingAuthCreditCard = ({
    refuelingRequestTransactionId,
    token,
    transactionId,
  }: {
    refuelingRequestTransactionId: string;
    token: string;
    transactionId: string;
  }) =>
    this.post(`${SELF_SERVICE_REFUELING}/${CREDIT_CARD}/auth`, {
      refueling_request_transaction_id: refuelingRequestTransactionId,
      token,
      transaction_id: transactionId,
    });

  // 連鎖店 ----------

  chainStoreCreateTransaction = ({
    invoiceId,
    email,
    receipt,
  }: {
    invoiceId: string;
    email: string;
    receipt: {};
  }) =>
    this.post(`${INVOICES}/${invoiceId}/invoice_transactions`, {
      email: email === '' ? null : email,
      receipt,
    });

  chainStoreCompleteApplePay = (
    captureType: string,
    {
      invoiceId,
      applePayPaymentInfo,
      email,
      receipt,
    }: {
      invoiceId: string;
      applePayPaymentInfo: {};
      email: string;
      receipt: {};
    },
  ) => {
    const entity =
      captureType === 'manual' ? 'auth_by_apple_pay' : 'pay_by_apple_pay';

    this.post(`${INVOICES}/${invoiceId}/${entity}`, {
      apple_pay_payment_info: applePayPaymentInfo,
      billing_contact: {
        email_address: email,
      },
      type: 'web',
      receipt,
    });
  };

  chainStoreComplete = (
    captureType: string,
    {
      invoiceId,
      invoiceTransactionId,
      token,
      transactionId,
    }: {
      invoiceId: string;
      invoiceTransactionId: string;
      token: string;
      transactionId: string;
    },
  ) => {
    const entity = captureType === 'manual' ? 'auth' : 'pay';

    return this.post(
      `${INVOICES}/${invoiceId}/invoice_transactions/${invoiceTransactionId}/${entity}`,
      {
        token,
        transaction_id: transactionId,
      },
    );
  };

  chainStoreInitLinePay = ({
    invoiceId,
    email,
    receipt,
    callbackUrl,
  }: {
    invoiceId: string;
    email: string;
    receipt: {};
    callbackUrl: string;
  }) =>
    this.post(`${INVOICES}/${LINE_PAY}/init`, {
      invoice_id: invoiceId,
      email: email === '' ? null : email,
      receipt,
      callback_url: callbackUrl,
    });

  chainStoreGetPaymentInfo = ({ invoiceId }: { invoiceId: string }) =>
    this.get(`/invoices/${invoiceId}`);

  chainStoreGetOrder = ({
    invoiceId,
    invoiceOrderId,
  }: {
    invoiceId: string;
    invoiceOrderId: string;
  }) => this.get(`${INVOICES}/${invoiceId}/orders/${invoiceOrderId}`);

  chainStoreInitEasyWallet = ({
    invoiceId,
    email,
    receipt,
    callbackUrl,
  }: {
    invoiceId: string;
    email: string;
    receipt: {};
    callbackUrl: string;
  }) =>
    this.post(`${INVOICES}/${EASY_WALLET}/init`, {
      invoice_id: invoiceId,
      email: email,
      callback_url: callbackUrl,
      receipt,
    });

  chainStoreConfirmEasyWallet = (transactionId: string) =>
    this.post(`${INVOICES}/${EASY_WALLET}/confirm`, {
      transaction_id: transactionId,
    });

  // 訪客查詢繳費 ----------

  apsCreateTransaction = ({
    parkingTicketId,
    email,
    receipt,
  }: {
    parkingTicketId: string;
    email: string;
    receipt: {};
  }) =>
    this.post(`${PARKING_TICKETS}/${parkingTicketId}/create_transaction`, {
      email: email === '' ? null : email,
      receipt,
    });

  apsAuthApplePay = ({
    parkingTicketId,
    applePayPaymentInfo,
    email,
    receipt,
  }: {
    parkingTicketId: string;
    applePayPaymentInfo: {};
    email: string;
    receipt: {};
  }) =>
    this.post(`${PARKING_TICKETS}/${APPLE_PAY}/pay`, {
      parking_ticket_id: parkingTicketId,
      apple_pay_payment_info: applePayPaymentInfo,
      billing_contact: {
        email_address: email,
      },
      type: 'web',
      receipt,
    });

  apsInitLinePay = ({
    parkingTicketId,
    email,
    receipt,
    callbackUrl,
  }: {
    parkingTicketId: string;
    email: string;
    receipt: {};
    callbackUrl: string;
  }) =>
    this.post(`${PARKING_TICKETS}/${LINE_PAY}/init`, {
      parking_ticket_id: parkingTicketId,
      email: email === '' ? null : email,
      receipt,
      callback_url: callbackUrl,
    });

  apsGetOrder = ({
    parkingTicketId,
    parkingOrderId,
  }: {
    parkingTicketId: string;
    parkingOrderId: string;
  }) =>
    this.get(`${PARKING_TICKETS}/${parkingTicketId}/orders/${parkingOrderId}`);

  apsInitEasyWallet = ({
    parkingTicketId,
    email,
    callbackUrl,
    receipt,
  }: {
    parkingTicketId: string;
    email: string;
    callbackUrl: string;
    receipt: {};
  }) =>
    this.post(`${PARKING_TICKETS}/${EASY_WALLET}/init`, {
      parking_ticket_id: parkingTicketId,
      type: 'web',
      email,
      receipt,
      callback_url: callbackUrl,
    });

  apsConfirmEasyWallet = (transactionId: string) =>
    this.post(`${PARKING_TICKETS}/${EASY_WALLET}/confirm`, {
      transaction_id: transactionId,
    });

  apsInitJkoPay = ({
    parkingTicketId,
    email,
    callbackUrl,
    receipt,
  }: {
    parkingTicketId: string;
    email: string;
    callbackUrl: string;
    receipt: {};
  }) =>
    this.post(`${PARKING_TICKETS}/${JKOPAY}/init`, {
      parking_ticket_id: parkingTicketId,
      type: 'web',
      email,
      receipt,
      callback_url: callbackUrl,
    });

  apsConfirmJkoPay = (transactionId: string) =>
    this.post(`${PARKING_TICKETS}/${JKOPAY}/confirm`, {
      transaction_id: transactionId,
    });

  apsAuthCreditCard = ({
    parkingTicketTransactionId,
    token,
    transactionId,
  }: {
    parkingTicketTransactionId: string;
    token: string;
    transactionId: string;
  }) =>
    this.post(`${PARKING_TICKETS}/${CREDIT_CARD}/pay`, {
      parking_ticket_transaction_id: parkingTicketTransactionId,
      token,
      transaction_id: transactionId,
    });

  // 訪客車辨

  guestAlprBindCreditCard = ({
    parkingRecordId,
    callbackUrl,
    email,
    receipt,
    vehicleType,
  }: {
    parkingRecordId: string;
    callbackUrl: string;
    email: string;
    receipt: {};
    vehicleType: string;
  }) =>
    this.post(`${GUEST_ALPR_SERVICE}/${CREDIT_CARD}/bind`, {
      parking_record_id: parkingRecordId,
      frontend_url: callbackUrl,
      email,
      receipt,
      vehicleType,
    });

  guestAlprBindLinePay = ({
    parkingRecordId,
    callbackUrl,
    email,
    receipt,
  }: {
    parkingRecordId: string;
    callbackUrl: string;
    email: string;
    receipt: {};
  }) =>
    this.post(`${GUEST_ALPR_SERVICE}/${LINE_PAY}/bind`, {
      parking_record_id: parkingRecordId,
      frontend_url: callbackUrl,
      email,
      receipt,
    });

  guestAlprConfirmCreditCard = (transactionId: string) =>
    this.post(`${GUEST_ALPR_SERVICE}/${CREDIT_CARD}/confirm`, {
      transaction_id: transactionId,
    });

  guestAlprConfirmLinePay = (transactionId: string) =>
    this.post(`${GUEST_ALPR_SERVICE}/${LINE_PAY}/confirm`, {
      transaction_id: transactionId,
    });

  // common

  initLinePay = ({
    amount,
    merchantUid,
    orderType,
    transactionType,
    confirmUrl,
    cancelUrl,
  }: {
    amount: number;
    merchantUid: string;
    orderType: string;
    transactionType: string;
    confirmUrl: string;
    cancelUrl: string;
  }) =>
    this.paymentPost(`${LINE_PAY}/init_auth_payment`, {
      amount: amount,
      order_type: orderType,
      transaction_type: transactionType,
      merchant_uid: merchantUid,
      confirm_url: confirmUrl,
      cancel_url: cancelUrl,
    });

  confirmLinePay = (transactionId: string) =>
    this.paymentPost(`${LINE_PAY}/confirm_auth_payment`, {
      transaction_id: transactionId,
    });

  getApplePaySessionValidation = ({
    transactionType,
    sessionUrl,
  }: {
    transactionType: string;
    sessionUrl: string;
  }) =>
    this.post(`${APPLE_PAY}/session_validation`, {
      session_url: sessionUrl,
      transaction_type: transactionType,
    });

  // 驗證載具號碼是否存在
  validateBarcode = (barcode: string) =>
    this.get(
      `einvoice/validate_mobile_barcode?barcode=/${encodeURIComponent(
        barcode,
      )}`,
    );
}

export default PaymentHttpClient;
